export const toArray = (set) => Array.from(set.values()); // .values() нужно для IE

export const intersection = (first, second) => new Set(toArray(first).filter((item) => second.has(item)));
export const intersects = (first, second) => intersection(first, second).size > 0;
